"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;

var lodash_1 = require("lodash");

var polished_1 = require("polished");

var React = require("react");

var styled_components_1 = require("styled-components");

var utils_1 = require("../utils");

var Clickable_1 = require("./Clickable");

var Flex_1 = require("./Flex");

var SPINNER_HEIGHT = 30;
var spinKeyframes = styled_components_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n}"], ["\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n}"])));

var spinnerStyling = function spinnerStyling(_a) {
  var textColor = _a.textColor;
  return styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: transparent !important;\n  pointer-events: none;\n  position: relative;\n  text-index: -9999px;\n  opacity: 0.75;\n  &::after {\n    display: block;\n    content: '';\n    border-color: ", ";\n    animation: ", " 820ms infinite linear;\n    border-width: ", "px;\n    border-style: solid;\n    border-radius: 100%;\n    border-right-color: transparent;\n    border-top-color: transparent;\n    left: 50%;\n    margin-left: -", "px;\n    margin-top: -", "px;\n    position: absolute;\n    top: 48%;\n    height: ", "px;\n    width: ", "px;\n  }\n"], ["\n  color: transparent !important;\n  pointer-events: none;\n  position: relative;\n  text-index: -9999px;\n  opacity: 0.75;\n  &::after {\n    display: block;\n    content: '';\n    border-color: ", ";\n    animation: ", " 820ms infinite linear;\n    border-width: ", "px;\n    border-style: solid;\n    border-radius: 100%;\n    border-right-color: transparent;\n    border-top-color: transparent;\n    left: 50%;\n    margin-left: -", "px;\n    margin-top: -", "px;\n    position: absolute;\n    top: 48%;\n    height: ", "px;\n    width: ", "px;\n  }\n"])), textColor, spinKeyframes, SPINNER_HEIGHT * 0.05, SPINNER_HEIGHT * 0.25, SPINNER_HEIGHT * 0.25, SPINNER_HEIGHT * 0.5, SPINNER_HEIGHT * 0.5);
};

var ButtonInner = styled_components_1.default(function (_a) {
  var $themeStyles = _a.$themeStyles,
      fullWidth = _a.fullWidth,
      loading = _a.loading,
      $beforeFocus = _a.$beforeFocus,
      rest = __rest(_a, ["$themeStyles", "fullWidth", "loading", "$beforeFocus"]);

  return React.createElement(Clickable_1.Clickable, __assign({}, rest));
})(function (_a) {
  var theme = _a.theme,
      themeStyles = _a.$themeStyles,
      _b = _a.variant,
      variant = _b === void 0 ? 'default' : _b,
      loading = _a.loading,
      fullWidth = _a.fullWidth,
      $beforeFocus = _a.$beforeFocus;
  var shadow = "0px 2px 5px " + polished_1.transparentize(0.5, lodash_1.get(theme, "components.Button.variants." + variant + ".backgroundColor"));
  return styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      position: relative;\n      font-family: inherit;\n      display: inline-flex;\n      justify-content: center;\n      align-items: center;\n      text-align: center;\n      cursor: pointer;\n      text-transform: capitalize;\n      font-weight: bold;\n      border: 1px solid transparent;\n      transition: 175ms;\n      width: auto;\n      box-shadow: ", ";\n\n      && {\n        appearance: none;\n      }\n\n      &::before {\n        content: '';\n        position: absolute;\n        left: -4px;\n        top: -4px;\n        width: 100%;\n        height: 100%;\n        padding: 3px;\n        border-radius: ", ";\n        border: 1px solid transparent;\n        transition: border-color 0.2s;\n      }\n\n      ", "\n\n      ", ";\n\n      ", "\n\n      ", ";\n\n      &:disabled {\n        background-color: ", ";\n        border-color: ", ";\n        color: ", ";\n      }\n    "], ["\n      position: relative;\n      font-family: inherit;\n      display: inline-flex;\n      justify-content: center;\n      align-items: center;\n      text-align: center;\n      cursor: pointer;\n      text-transform: capitalize;\n      font-weight: bold;\n      border: 1px solid transparent;\n      transition: 175ms;\n      width: auto;\n      box-shadow: ", ";\n\n      && {\n        appearance: none;\n      }\n\n      &::before {\n        content: '';\n        position: absolute;\n        left: -4px;\n        top: -4px;\n        width: 100%;\n        height: 100%;\n        padding: 3px;\n        border-radius: ", ";\n        border: 1px solid transparent;\n        transition: border-color 0.2s;\n      }\n\n      ", "\n\n      ", ";\n\n      ", "\n\n      ", ";\n\n      &:disabled {\n        background-color: ", ";\n        border-color: ", ";\n        color: ", ";\n      }\n    "])), shadow, theme.borderRadius, $beforeFocus && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n          &:focus {\n            &::before {\n              border-color: ", ";\n              transition: border-color 0.2s;\n            }\n          }\n        "], ["\n          &:focus {\n            &::before {\n              border-color: ", ";\n              transition: border-color 0.2s;\n            }\n          }\n        "])), theme.colors.primary), loading && spinnerStyling({
    textColor: themeStyles.color
  }), fullWidth && styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n          width: 100%;\n        "], ["\n          width: 100%;\n        "]))), themeStyles, themeStyles.disabledBackgroundColor || polished_1.tint(0.3, themeStyles.backgroundColor), themeStyles.disabledBorderColor || polished_1.tint(0.3, themeStyles.backgroundColor), themeStyles.disabledColor || polished_1.tint(0.3, themeStyles.color));
});

function Button(_a) {
  var leftIcon = _a.leftIcon,
      leftIconProps = _a.leftIconProps,
      rightIcon = _a.rightIcon,
      rightIconProps = _a.rightIconProps,
      children = _a.children,
      _b = _a.variant,
      variant = _b === void 0 ? 'default' : _b,
      beforeFocus = _a.beforeFocus,
      _c = _a.onClick,
      onClick = _c === void 0 ? function () {
    return null;
  } : _c,
      _d = _a.disabled,
      disabled = _d === void 0 ? false : _d,
      style = _a.style,
      _e = _a.size,
      size = _e === void 0 ? 'md' : _e,
      other = __rest(_a, ["leftIcon", "leftIconProps", "rightIcon", "rightIconProps", "children", "variant", "beforeFocus", "onClick", "disabled", "style", "size"]);

  var theme = styled_components_1.useTheme();

  var _f = utils_1.getComponentThemeStyles(theme, 'Button', variant, size),
      iconSize = _f.iconSize,
      themeStyles = __rest(_f, ["iconSize"]);

  var iconStyle = {
    size: iconSize
  };

  var leftIconStyle = __assign({
    marginRight: children && '8px'
  }, iconStyle);

  var rightIconStyle = __assign({
    marginLeft: children && '8px'
  }, iconStyle);

  return React.createElement(ButtonInner, __assign({
    variant: variant,
    onClick: onClick,
    disabled: disabled,
    style: style,
    size: size,
    "$themeStyles": themeStyles,
    "$beforeFocus": beforeFocus
  }, other), React.createElement(React.Fragment, null, leftIcon && React.createElement(leftIcon, __assign({
    style: leftIconStyle
  }, leftIconProps)), children, rightIcon && React.createElement(rightIcon, __assign({
    style: rightIconStyle
  }, rightIconProps))));
}

exports.Button = Button;

var verticalCss = function verticalCss(_a) {
  var breakpoints = _a.breakpoints,
      isConnected = _a.isConnected,
      borderRadius = _a.borderRadius,
      vertical = _a.vertical;
  var maybeNumber = parseInt(vertical, 10);
  var fallback = breakpoints[vertical] || breakpoints.sm;
  var breakpoint = Number.isInteger(maybeNumber) ? maybeNumber + "px" : fallback;
  return styled_components_1.css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    @media (max-width: ", ") {\n      flex-direction: column;\n\n      & > button,\n      & > a {\n        margin-left: 0;\n      }\n\n      & > :not(:first-child) {\n        margin: 1rem 0 0;\n      }\n\n      ", "\n    }\n  "], ["\n    @media (max-width: ", ") {\n      flex-direction: column;\n\n      & > button,\n      & > a {\n        margin-left: 0;\n      }\n\n      & > :not(:first-child) {\n        margin: 1rem 0 0;\n      }\n\n      ", "\n    }\n  "])), breakpoint, isConnected && styled_components_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n          & > :not(:first-child) {\n            margin-top: 0;\n          }\n          & > :first-child {\n            border-radius: ", " ", " 0 0;\n          }\n          & > :last-child {\n            border-radius: 0 0 ", " ", ";\n          }\n          & > :not(:first-child):not(:last-child) {\n            border-radius: 0;\n          }\n        "], ["\n          & > :not(:first-child) {\n            margin-top: 0;\n          }\n          & > :first-child {\n            border-radius: ", " ", " 0 0;\n          }\n          & > :last-child {\n            border-radius: 0 0 ", " ", ";\n          }\n          & > :not(:first-child):not(:last-child) {\n            border-radius: 0;\n          }\n        "])), borderRadius, borderRadius, borderRadius, borderRadius));
};

Button.Group = styled_components_1.default(Flex_1.Flex)(function (_a) {
  var _b = _a.isConnected,
      isConnected = _b === void 0 ? false : _b,
      _c = _a.theme,
      radius = _c.borderRadius,
      breakpoints = _c.breakpoints,
      vertical = _a.vertical,
      _d = _a.borderRadius,
      borderRadius = _d === void 0 ? radius || '2px' : _d;
  return styled_components_1.css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      justify-content: space-between;\n\n      & > button,\n      & > a {\n        flex: 1;\n      }\n\n      & > :not(:first-child) {\n        margin-left: 1rem;\n      }\n\n      ", "\n\n      ", "\n    "], ["\n      justify-content: space-between;\n\n      & > button,\n      & > a {\n        flex: 1;\n      }\n\n      & > :not(:first-child) {\n        margin-left: 1rem;\n      }\n\n      ", "\n\n      ", "\n    "])), isConnected && styled_components_1.css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n          & > :not(:first-child) {\n            margin-left: 0;\n          }\n          & > :first-child {\n            border-radius: ", " 0 0 ", ";\n          }\n          & > :last-child {\n            border-radius: 0 ", " ", " 0;\n          }\n          & > :not(:first-child):not(:last-child) {\n            border-radius: 0;\n          }\n        "], ["\n          & > :not(:first-child) {\n            margin-left: 0;\n          }\n          & > :first-child {\n            border-radius: ", " 0 0 ", ";\n          }\n          & > :last-child {\n            border-radius: 0 ", " ", " 0;\n          }\n          & > :not(:first-child):not(:last-child) {\n            border-radius: 0;\n          }\n        "])), borderRadius, borderRadius, borderRadius, borderRadius), verticalCss({
    breakpoints: breakpoints,
    isConnected: isConnected,
    borderRadius: borderRadius,
    vertical: vertical
  }));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;